import { VerificationStatus } from "shared/types";

export const CanadianCriminalReportStatus = ({
  status
}: {
  status: VerificationStatus;
}) => {
  if (status === VerificationStatus.Finished)
    return <p className="text-content-1000 text-sm font-medium">Done</p>;

  if (status === VerificationStatus.Skipped)
    return (
      <p className="text-content-200 text-sm font-medium">
        Wasn’t a Canadian resident
      </p>
    );

  return "-";
};
